import { Menu, Transition } from '@headlessui/react';
import { UserIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { useAuth } from 'lib/auth';
import React, { useEffect, useState } from 'react';
import { Clock, LogOut, Settings } from 'react-feather';
import { Link } from 'react-router-dom';
import AvatarImg from 'assets/avatar.png';
import { imageToBlob } from 'utils/ImageToBlob';
import { Text } from 'components/Elements';

export const UserNavigation = () => {
  const { user, logout } = useAuth();

  const [userPhoto, setUserPhoto] = useState('');
  const [photoLoaded, setPhotoLoaded] = useState(false);

  // Convert user's photo to Blob
  useEffect(() => {
    let objectUrl;

    if (user?.photo) {
      imageToBlob(user.photo).then((localURL) => {
        if (localURL) {
          setUserPhoto(localURL);
          objectUrl = localURL;
        }
      });
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [user?.photo]);

  const userNavigation = [
    {
      name: 'My account',
      icon: <UserIcon className="h-4" />,
      to: './account',
    },
    {
      name: 'Log out',
      icon: <LogOut className="h-4" />,
      to: '',
      onClick: () => {
        logout();
      },
    },
  ].filter(Boolean);

  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <Menu.Button>
            <div className="w-12 h-12 rounded-full drop-shadow-md flex flex-row items-center space-x-2 mr-48">
              <img
                src={userPhoto || AvatarImg}
                alt="User Avatar"
                className="w-full h-full object-cover"
                style={{ display: photoLoaded ? 'block' : 'none' }}
                onLoad={() => setPhotoLoaded(true)}
                onError={() => setPhotoLoaded(true)}
              />
              <div className="flex flex-col items-start">
                <Text className='font-bold'>Jonathan</Text>
                <Text className='text-xs'>jonathan@wire24.co</Text>
              </div>
            </div>
          </Menu.Button>
          <Transition
            show={open}
            as={React.Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 dark:bg-gray-700 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              {userNavigation.map((item) => (
                <Menu.Item key={item.name}>
                  {({ active }) => (
                    <Link
                      onClick={item.onClick}
                      to={item.to}
                      className={clsx(
                        `flex flex-row items-center`,
                        active ? 'bg-gray-100 dark:bg-gray-700' : '',
                        'block px-4 py-2 text-sm text-gray-700 dark:text-gray-400'
                      )}
                    >
                      {item.icon}
                      <span className="ml-2">{item.name}</span>
                    </Link>
                  )}
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
